import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { v4 as uuidv4 } from 'uuid';

const TrackingContext = createContext(null);

export const TrackingProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Generate or retrieve a session ID for tracking anonymous users
    let storedSessionId = localStorage.getItem('tracking_session_id');
    if (!storedSessionId) {
      storedSessionId = uuidv4();
      localStorage.setItem('tracking_session_id', storedSessionId);
    }
    setSessionId(storedSessionId);
  }, []);

  const trackEvent = async (action, targetId = null, targetModel = null, metadata = {}) => {
    try {
      if (!sessionId && action !== 'PAGE_VIEW') return; // ensure session id is ready
      
      await api.post('/activity/track', {
        sessionId: sessionId || localStorage.getItem('tracking_session_id'),
        action,
        targetId,
        targetModel,
        metadata
      });
    } catch (error) {
      console.error('Failed to track activity:', error);
    }
  };

  return (
    <TrackingContext.Provider value={{ trackEvent }}>
      {children}
    </TrackingContext.Provider>
  );
};

export const useTracking = () => {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error('useTracking must be used within a TrackingProvider');
  }
  return context;
};
